// GENERATED by scripts/gen-date-names.mjs from Node's full ICU (CLDR) — do not edit.
// Month names and date patterns per app locale, so a date never depends on how much
// locale data the reader's browser or phone happens to ship (C22, 2026-10-19).
export type DateToken = { f: 'day' | 'month' | 'year' } | { lit: string };
export interface DateNames {
  monthsShort: string[];
  monthsLong: string[];
  dayMonthYear: DateToken[];
  dayMonth: DateToken[];
  monthYear: DateToken[];
}
export const DATE_NAMES: Record<string, DateNames> = {
  "en-IN": {
    monthsShort: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sept","Oct","Nov","Dec"],
    monthsLong: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":" "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "hi-IN": {
    monthsShort: ["जन॰","फ़र॰","मार्च","अप्रैल","मई","जून","जुल॰","अग॰","सित॰","अक्टू॰","नव॰","दिस॰"],
    monthsLong: ["जनवरी","फ़रवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितंबर","अक्टूबर","नवंबर","दिसंबर"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":" "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "bn-IN": {
    monthsShort: ["জানু","ফেব","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেঃ","অক্টোঃ","নভেঃ","ডিসেঃ"],
    monthsLong: ["জানুয়ারি","ফেব্রুয়ারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":", "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "ta-IN": {
    monthsShort: ["ஜன.","பிப்.","மார்.","ஏப்.","மே","ஜூன்","ஜூலை","ஆக.","செப்.","அக்.","நவ.","டிச."],
    monthsLong: ["ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","மே","ஜூன்","ஜூலை","ஆகஸ்ட்","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":", "},{"f":"year"}],
    dayMonth: [{"f":"month"},{"lit":" "},{"f":"day"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "te-IN": {
    monthsShort: ["జన","ఫిబ్ర","మార్చి","ఏప్రి","మే","జూన్","జులై","ఆగ","సెప్టెం","అక్టో","నవం","డిసెం"],
    monthsLong: ["జనవరి","ఫిబ్రవరి","మార్చి","ఏప్రిల్","మే","జూన్","జులై","ఆగస్టు","సెప్టెంబర్","అక్టోబర్","నవంబర్","డిసెంబర్"],
    dayMonthYear: [{"f":"day"},{"lit":", "},{"f":"month"},{"lit":" "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "mr-IN": {
    monthsShort: ["जाने","फेब्रु","मार्च","एप्रि","मे","जून","जुलै","ऑग","सप्टें","ऑक्टो","नोव्हें","डिसें"],
    monthsLong: ["जानेवारी","फेब्रुवारी","मार्च","एप्रिल","मे","जून","जुलै","ऑगस्ट","सप्टेंबर","ऑक्टोबर","नोव्हेंबर","डिसेंबर"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":", "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "kn-IN": {
    monthsShort: ["ಜನ","ಫೆಬ್ರ","ಮಾರ್ಚ್","ಏಪ್ರಿ","ಮೇ","ಜೂನ್","ಜುಲೈ","ಆಗ","ಸೆಪ್ಟೆಂ","ಅಕ್ಟೋ","ನವೆಂ","ಡಿಸೆಂ"],
    monthsLong: ["ಜನವರಿ","ಫೆಬ್ರವರಿ","ಮಾರ್ಚ್","ಏಪ್ರಿಲ್","ಮೇ","ಜೂನ್","ಜುಲೈ","ಆಗಸ್ಟ್","ಸೆಪ್ಟೆಂಬರ್","ಅಕ್ಟೋಬರ್","ನವೆಂಬರ್","ಡಿಸೆಂಬರ್"],
    dayMonthYear: [{"f":"month"},{"lit":" "},{"f":"day"},{"lit":","},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "gu-IN": {
    monthsShort: ["જાન્યુ","ફેબ્રુ","માર્ચ","એપ્રિલ","મે","જૂન","જુલાઈ","ઑગસ્ટ","સપ્ટે","ઑક્ટો","નવે","ડિસે"],
    monthsLong: ["જાન્યુઆરી","ફેબ્રુઆરી","માર્ચ","એપ્રિલ","મે","જૂન","જુલાઈ","ઑગસ્ટ","સપ્ટેમ્બર","ઑક્ટોબર","નવેમ્બર","ડિસેમ્બર"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":", "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "pa-IN": {
    monthsShort: ["ਜਨ","ਫ਼ਰ","ਮਾਰਚ","ਅਪ੍ਰੈ","ਮਈ","ਜੂਨ","ਜੁਲਾ","ਅਗ","ਸਤੰ","ਅਕਤੂ","ਨਵੰ","ਦਸੰ"],
    monthsLong: ["ਜਨਵਰੀ","ਫ਼ਰਵਰੀ","ਮਾਰਚ","ਅਪ੍ਰੈਲ","ਮਈ","ਜੂਨ","ਜੁਲਾਈ","ਅਗਸਤ","ਸਤੰਬਰ","ਅਕਤੂਬਰ","ਨਵੰਬਰ","ਦਸੰਬਰ"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":" "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "as-IN": {
    monthsShort: ["জানু","ফেব্ৰু","মাৰ্চ","এপ্ৰিল","মে’","জুন","জুলাই","আগ","ছেপ্তে","অক্টো","নৱে","ডিচে"],
    monthsLong: ["জানুৱাৰী","ফেব্ৰুৱাৰী","মাৰ্চ","এপ্ৰিল","মে’","জুন","জুলাই","আগষ্ট","ছেপ্তেম্বৰ","অক্টোবৰ","নৱেম্বৰ","ডিচেম্বৰ"],
    dayMonthYear: [{"f":"day"},{"lit":" "},{"f":"month"},{"lit":" "},{"f":"year"}],
    dayMonth: [{"f":"day"},{"lit":" "},{"f":"month"}],
    monthYear: [{"f":"month"},{"lit":" "},{"f":"year"}],
  },
  "ml-IN": {
    monthsShort: ["ജനു","ഫെബ്രു","മാർ","ഏപ്രി","മേയ്","ജൂൺ","ജൂലൈ","ഓഗ","സെപ്റ്റം","ഒക്ടോ","നവം","ഡിസം"],
    monthsLong: ["ജനുവരി","ഫെബ്രുവരി","മാർച്ച്","ഏപ്രിൽ","മേയ്","ജൂൺ","ജൂലൈ","ഓഗസ്റ്റ്","സെപ്റ്റംബർ","ഒക്‌ടോബർ","നവംബർ","ഡിസംബർ"],
    dayMonthYear: [{"f":"year"},{"lit":" "},{"f":"month"},{"lit":" "},{"f":"day"}],
    dayMonth: [{"f":"month"},{"lit":" "},{"f":"day"}],
    monthYear: [{"f":"year"},{"lit":" "},{"f":"month"}],
  },
};
